import { Logged } from "@/routing";
import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement } from "react";

export const Pro: FunctionComponent = observer((): ReactElement => {
  return (
    <Logged>
      <div
        style={{
          position: "fixed",
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          Идет закрытое тестирование...
        </div>
      </div>
    </Logged>
  );
});
